/* solutionsManager.icon.svg.js */

'use strict';
module.exports = {
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path class="foreground-gl" d="M6 6C4.9 6 4 6.9 4 8V21C4 22.1 4.9 23 6 23H19C20.1 23 21 22.1 21 21V17.2H19.5C18.01 17.2 16.8 15.99 16.8 14.5C16.8 13.01 18.01 11.8 19.5 11.8H20.99V8C20.99 6.9 20.1 6 19 6H15V4.5C15 3.12 13.88 2 12.5 2C11.12 2 10 3.12 10 4.5V6H6Z" fill="#748594"/>
    </svg>
    `
};